import React, { Suspense, lazy } from "react";
import { ErrorBoundary } from "react-error-boundary";

import _ErrorBoundaryFallback from "../error-boundary-fallback";
import ContinuousProgressBar from "../continuos-progress-bar";

export default function withLoadable(lazyImport, config = {}) {
  const { suspenseFallback = null, ErrorBoundaryFallback = _ErrorBoundaryFallback } = config;

  const Component = lazy(lazyImport);
  const suspenseProps = {};

  if (suspenseFallback) {
    suspenseProps.fallback = suspenseFallback;
  }
  if (!suspenseFallback) {
    suspenseProps.fallback = <ContinuousProgressBar />;
  }

  return function Loadable(props) {
    return (
      <ErrorBoundary FallbackComponent={ErrorBoundaryFallback}>
        <Suspense {...suspenseProps}>
          <Component {...props} />
        </Suspense>
      </ErrorBoundary>
    );
  };
}
